import React from 'react';
import { PublicHeader, PublicFooter } from '../components/PublicLayout';

export default function TermsPage() {
  return (
    <>
      <PublicHeader />
      <main className="bg-[#FBF7EF] min-h-screen">
        <article className="max-w-[800px] mx-auto px-4 sm:px-6 py-16 prose prose-neutral">
          <h1 className="news-masthead text-3xl font-bold mb-8">Terms of Service</h1>
          <p className="text-xs text-[#5B616E] mb-8">Last updated: {new Date().toLocaleDateString()}</p>
          
          <h2>1. Acceptance of Terms</h2>
          <p>By accessing Neural News, you agree to these Terms of Service. If you disagree with any part, you may not access our service.</p>
          
          <h2>2. User Accounts</h2>
          <p>You must provide accurate information when creating an account. You are responsible for maintaining account security and all activities under your account. Notify us immediately of unauthorized access.</p>
          
          <h2>3. Content and Intellectual Property</h2>
          <p>All editorial content, including articles, images, and multimedia, is protected by copyright. You may share articles via official sharing mechanisms but may not reproduce, distribute, or create derivative works without written permission.</p>
          
          <h2>4. User-Generated Content</h2>
          <p>By submitting comments, tips, or UGC, you grant Neural News a non-exclusive, royalty-free license to use, display, and distribute your content. You retain ownership but represent that you have the right to share it.</p>
          
          <h2>5. Commenting Guidelines</h2>
          <p>Comments must be civil and relevant. We prohibit: hate speech, personal attacks, spam, misinformation, and illegal content. We reserve the right to moderate and remove comments that violate these guidelines.</p>
          
          <h2>6. Subscriptions</h2>
          <p>Paid subscriptions auto-renew unless cancelled. Subscriptions bought in our iOS app are billed by Apple: cancel them in your Apple Account settings and request refunds from Apple. For subscriptions bought on our website, refunds are available within 14 days of initial purchase. We reserve the right to modify pricing with 30 days notice.</p>
          
          <h2>7. Limitation of Liability</h2>
          <p>Neural News provides journalism to the best of our professional standards. We are not liable for decisions made based on our content. We implement corrections promptly when errors are identified.</p>
          
          <h2>8. Termination</h2>
          <p>We may suspend or terminate accounts that violate these terms. You may delete your account at any time through Settings or by contacting support.</p>

          <h2>9. Governing Law</h2>
          <p>These terms are governed by the laws of England and Wales. Disputes shall be resolved in the courts of England and Wales.</p>
          
          <h2>10. Contact</h2>
          <p>Legal enquiries: legal@neuralsignal.co.uk<br />General: support@neuralsignal.co.uk</p>
        </article>
      </main>
      <PublicFooter />
    </>
  );
}
